import PropTypes from 'prop-types';
import React from 'react';

//components
import AbstractIcon from 'components/AbstractIcon';

//known icons
import icons from 'icons/icons.json';

const IconComponent = props => <AbstractIcon {...props} icons={icons} />;

IconComponent.propTypes = {
  size: PropTypes.number,
  name: PropTypes.oneOf(Object.keys(icons))
};

export default IconComponent;
